import { paymentThunk, getSubsciptionHistoryThunk } from '../../../../../store/workspace/thunks';
import { setConfirmCancelSubscriptionModal } from '../../../../../store/workspace/slice';
import { setNotification } from '../../../../../store/general/slice';
import { CancelPlanSquareIcon } from '../../../../../assets/icons';
import CheckBox from '../../../../../components/CheckBox';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import { useState } from 'react';

interface Reason {
    id: number;
    text: string;
}

const reasonList: Reason[] = [
    {
        id: 1,
        text: 'I don’t have time to use it right now'
    },
    {
        id: 2,
        text: 'It feels too expensive for my current needs'
    },
    {
        id: 3,
        text: 'I’ve already hired or completed my project'
    },
    {
        id: 4,
        text: 'I’m not sure how to get the most out of it'
    },
    {
        id: 5,
        text: 'It’s not what I expected'
    },
    {
        id: 6,
        text: 'I was only trying it temporarily'
    },
    {
        id: 7,
        text: 'I plan to return and subscribe later'
    },
    {
        id: 8,
        text: 'Other'
    },
];

export default function ConfirmCancelSubscription() {
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [comment, setComment] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [selectedReason, setSelectedReason] = useState<Reason | null>(null);

    const confirm = () => {
        if (!selectedReason) return
        setIsLoading(true);
        setError('');

        dispatch(paymentThunk({
            action: 'cancel_subscription',
            reason: selectedReason.text,
        }))
            .unwrap()
            .then(() => {
                dispatch(setConfirmCancelSubscriptionModal(false));
                dispatch(getSubsciptionHistoryThunk({
                    action: 'get_subscription_status',
                }));
            })
            .catch(error => {
                const message = error?.message || 'Something went wrong,Please try again.';
                setError(message);
                dispatch(setNotification([message, 'error']));
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <Modal
            size='sm'
            title='Cancel plan'
            icon={<CancelPlanSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setConfirmCancelSubscriptionModal(false))}
        >
            <div className={styles.text}>
                <b>We’re sorry to see you go!</b>
                <p>
                    Once canceled, you will continue to have access
                    to the plan until the end of your billing cycle.
                </p>
            </div>

            <div className={styles.reason}>
                <span>Please select reason for cancellation:</span>
                <div className={styles.reason_list}>
                    {reasonList.map(item => <CheckBox
                        key={item.id}
                        text={item.text}
                        checked={selectedReason?.id === item.id}
                        onClick={() => setSelectedReason(item)}
                    />)}
                    {selectedReason?.id === 8 && <Input
                        type='text'
                        value={comment}
                        onChange={setComment}
                        placeholder='please specify'
                    />}
                </div>
            </div>

            {error && <span className={styles.error}>{error}</span>}

            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Primary'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setConfirmCancelSubscriptionModal(false))}
                />
                <Button
                    type='Error'
                    text='Confirm'
                    onClick={confirm}
                    loading={isLoading}
                    className={styles.actions_btn}
                    disabled={!selectedReason || (selectedReason?.id === 8 && !comment)}
                />
            </div>
        </Modal>
    )
};
